import { z } from 'zod';
import { RawSchema } from '../models/rawSchema';
import { rawSchemaSchema } from '../models/rawSchema.schema';
import { schemaSchema } from '../models/schema.schema';

/**
 * @noSchema
 */
const validateSchemaPayloadSchema = schemaSchema.partial();

/**
 * @noSchema
 */
type ValidateSchemaPayload = z.infer<typeof validateSchemaPayloadSchema>;

/**
 * @noSchema
 */
type ValidateRawSchemaPayload = Partial<RawSchema>;

export const validate = (payload: ValidateSchemaPayload) => {
  return {
    endpoint: `schemas/validate`,
    method: 'POST',
    responseSchema: z.any(),
    payload,
    payloadSchema: validateSchemaPayloadSchema,
  } as const;
};

export const validateRaw = (payload: ValidateRawSchemaPayload) => {
  return {
    endpoint: `schemas/validate`,
    method: 'POST',
    responseSchema: z.any(),
    payload,
    payloadSchema: rawSchemaSchema.partial(),
  } as const;
};
